module.exports = __webpack_public_path__ + "static/media/intelligentApplication.865c511c.png";